'use client';

import { RotateCcwIcon } from 'lucide-react';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { VictorMark } from '@/components/victor-mark';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex h-screen flex-col items-center justify-center px-4">
      <VictorMark className="h-16 w-16 text-border" />

      <h1 className="my-6 font-pixelify text-8xl font-medium tracking-tighter tabular-nums">
        500
      </h1>

      <p className="mb-6 text-center font-mono text-sm text-muted-foreground">
        Something went wrong.
      </p>

      <Button variant="default" onClick={reset}>
        Try again
        <RotateCcwIcon />
      </Button>
    </div>
  );
}
